// src/components/CanvasContainer.js
import React, { Suspense, lazy, useMemo, useState, useEffect } from "react";
import TopBar from "./common/TopBar.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import "../App.css";

const DefaultLayout = lazy(() => import("./layouts/Cards/product_id_1780.js"));
const layoutMap = {

  // ==================================================== //
  // Photo Products Dummy
  4285 : () => import("./layouts/Apparel and Wearable/T-Shirt/product_id_1912.js"),

  // Apparel and Wearable's Layouts Starts
  // Apparel and Wearable -> T-Shirt Category Layouts Starts
  1912: () => import("./layouts/Apparel and Wearable/T-Shirt/product_id_1912.js"),
  1919: () => import("./layouts/Apparel and Wearable/T-Shirt/product_id_1919.js"),
  1926: () => import("./layouts/Apparel and Wearable/T-Shirt/product_id_1926.js"),
  1927: () => import("./layouts/Apparel and Wearable/T-Shirt/product_id_1927.js"),
  // Apparel and Wearable -> T-Shirt Category Layouts Ends
  // Apparel and Wearable's Layouts Starts

  // ==================================================== //

  // Calendar's Category Layouts Starts
  // Calendar -> Poster Calendar Category Layouts Starts
  1937: () => import("./layouts/Calendar/Poster Calendar/product_id_1937.js"),
  1939: () => import("./layouts/Calendar/Poster Calendar/product_id_1939.js"),
  1942: () => import("./layouts/Calendar/Poster Calendar/product_id_1942.js"),
  1944: () => import("./layouts/Calendar/Poster Calendar/product_id_1944.js"),
  1947: () => import("./layouts/Calendar/Poster Calendar/product_id_1947.js"),
  1949: () => import("./layouts/Calendar/Poster Calendar/product_id_1949.js"),
  1951: () => import("./layouts/Calendar/Poster Calendar/product_id_1951.js"),
  1953: () => import("./layouts/Calendar/Poster Calendar/product_id_1953.js"),
  1955: () => import("./layouts/Calendar/Poster Calendar/product_id_1955.js"),
  1957: () => import("./layouts/Calendar/Poster Calendar/product_id_1957.js"),
  1959: () => import("./layouts/Calendar/Poster Calendar/product_id_1959.js"),
  1961: () => import("./layouts/Calendar/Poster Calendar/product_id_1961.js"),
  1963: () => import("./layouts/Calendar/Poster Calendar/product_id_1963.js"),
  1966: () => import("./layouts/Calendar/Poster Calendar/product_id_1966.js"),
  1968: () => import("./layouts/Calendar/Poster Calendar/product_id_1968.js"),
  1970: () => import("./layouts/Calendar/Poster Calendar/product_id_1970.js"),
  1972: () => import("./layouts/Calendar/Poster Calendar/product_id_1972.js"),
  1975: () => import("./layouts/Calendar/Poster Calendar/product_id_1975.js"),
  1977: () => import("./layouts/Calendar/Poster Calendar/product_id_1977.js"),
  1982: () => import("./layouts/Calendar/Poster Calendar/product_id_1982.js"),
  1983: () => import("./layouts/Calendar/Poster Calendar/product_id_1983.js"),
  1985: () => import("./layouts/Calendar/Poster Calendar/product_id_1985.js"),
  // Calendar -> Poster Calendar Category Layouts Ends

  // Calendar -> Wall Calendar Category Layouts Starts
  1986: () => import("./layouts/Calendar/Wall Calendar/product_id_1986.js"),
  1988: () => import("./layouts/Calendar/Wall Calendar/product_id_1988.js"),
  1990: () => import("./layouts/Calendar/Wall Calendar/product_id_1990.js"),
  1992: () => import("./layouts/Calendar/Wall Calendar/product_id_1992.js"),
  1994: () => import("./layouts/Calendar/Wall Calendar/product_id_1994.js"),
  1997: () => import("./layouts/Calendar/Wall Calendar/product_id_1997.js"),
  1999: () => import("./layouts/Calendar/Wall Calendar/product_id_1999.js"),
  2001: () => import("./layouts/Calendar/Wall Calendar/product_id_2001.js"),
  // Calendar -> Wall Calendar Category Layouts Ends
  // Calendar's Category Layouts Ends

  // ==================================================== //

  // Personalized Items and Gift Idea Cateory Layouts Starts

   // Personalized Items and Gift Idea -> Mugs, Water Bottles, Steins and Drinkables Category Layouts Starts
  2083: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2083.js"),
  2085: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2085.js"),
  2087: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2087.js"),
  2089: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2089.js"),
  2091: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2091.js"),
  2093: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2093.js"),
  2095: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2095.js"),
  2097: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2097.js"),
  2099: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2099.js"),
  2101: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2101.js"),
  2102: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2102.js"),
  2103: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2103.js"),
  2104: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2104.js"),
  2106: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2106.js"),
  2108: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2108.js"),
  2110: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2110.js"),
  2112: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2112.js"),
  2114: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2114.js"),
  2116: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2116.js"),
  2118: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2118.js"),
  2120: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2120.js"),
  2121: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2121.js"),
  2123: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2123.js"),
  2125: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2125.js"),
  2127: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2127.js"),
  2129: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2129.js"),
  2131: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2131.js"),
  2133: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2133.js"),
  2135: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2135.js"),
  2137: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2137.js"),
  2140: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2140.js"),
  2142: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2142.js"),
  2144: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2144.js"),
  2146: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2146.js"),
  2148: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2148.js"),
  2151: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2151.js"),
  2153: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2153.js"),
  2155: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2155.js"),
  2157: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2157.js"),
  2159: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2159.js"),
  2161: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2161.js"),
  2163: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2163.js"),
  2165: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2165.js"),
  2167: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2167.js"),
  2169: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2169.js"),
  2171: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2171.js"),
  2173: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2173.js"),
  2175: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2175.js"),
  2177: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2177.js"),
  2179: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2179.js"),
  2182: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2182.js"),
  2184: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2184.js"),
  2186: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2186.js"),
  2188: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2188.js"),
  2190: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2190.js"),
  2192: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2192.js"),
  2194: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_2194.js"),
  6141: () => import("./layouts/Personalized Items and Gift Idea/Mugs, Water Bottles, Steins and Drinkables/product_id_6141.js"),
  // Personalized Items and Gift Idea -> Mugs, Water Bottles, Steins and Drinkables Category Layouts Ends

  // Personalized Items and Gift Idea -> Home and Office and Games Category Layouts Starts
  2050: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2050.js"),
  2057: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2057.js"),
  2058: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2058.js"),
  2059: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2059.js"),
  2060: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2060.js"),
  2061: () => import("./layouts/Personalized Items and Gift Idea/Home and Office/product_id_2061.js"),
  // Personalized Items and Gift Idea -> Home and Office Category Layouts Ends

  // Personalized Items and Gift Idea -> Fun and Games Category Layouts Starts
  2043: () => import("./layouts/Personalized Items and Gift Idea/Fun and Games/product_id_2043.js"),
  2046: () => import("./layouts/Personalized Items and Gift Idea/Fun and Games/product_id_2046.js"),
  // Personalized Items and Gift Idea -> Fun and Games Category Layouts Ends

  // Personalized Items and Gift Idea -> Ornaments Category Layouts Starts
  2031: () => import("./layouts/Personalized Items and Gift Idea/Ornaments/product_id_2031.js"),
  2034: () => import("./layouts/Personalized Items and Gift Idea/Ornaments/product_id_2034.js"),
  // Personalized Items and Gift Idea -> Ornaments Category Layouts Ends
  // Personalized Items and Gift Idea Cateory Layouts Ends

  // ==================================================== //



  // Cards Category Layouts Starts
  1773: () => import("./layouts/Cards/product_id_1773.js"),
  1775: () => import("./layouts/Cards/product_id_1775.js"),
  1778: () => import("./layouts/Cards/product_id_1778.js"),
  1780: () => import("./layouts/Cards/product_id_1780.js"),
  // Cards Category Layouts Ends

  // ==================================================== //

  // Photo Books Cateory Layouts Starts
  1903: () => import("./layouts/Photo Books/product_id_1903.js"),
  // Photo Books Cateory Layouts Ends
  
  // ==================================================== //

  // Posters and Collages Cateory Layouts Starts
  1822: () => import("./layouts/Posters and Collages/product_id_1822.js"),
  1827: () => import("./layouts/Posters and Collages/product_id_1827.js"),
  1829: () => import("./layouts/Posters and Collages/product_id_1829.js"),
  1831: () => import("./layouts/Posters and Collages/product_id_1831.js"),
  1833: () => import("./layouts/Posters and Collages/product_id_1833.js"),
  1835: () => import("./layouts/Posters and Collages/product_id_1835.js"),
  1836: () => import("./layouts/Posters and Collages/product_id_1836.js"),
  1838: () => import("./layouts/Posters and Collages/product_id_1838.js"),
  1840: () => import("./layouts/Posters and Collages/product_id_1840.js"),
  1842: () => import("./layouts/Posters and Collages/product_id_1842.js"),
  1843: () => import("./layouts/Posters and Collages/product_id_1843.js"),
  1844: () => import("./layouts/Posters and Collages/product_id_1844.js"),
  1845: () => import("./layouts/Posters and Collages/product_id_1845.js"),
  1846: () => import("./layouts/Posters and Collages/product_id_1846.js"),
  1847: () => import("./layouts/Posters and Collages/product_id_1847.js"),
  1848: () => import("./layouts/Posters and Collages/product_id_1848.js"),
  1849: () => import("./layouts/Posters and Collages/product_id_1849.js"),
  1850: () => import("./layouts/Posters and Collages/product_id_1850.js"),
  1851: () => import("./layouts/Posters and Collages/product_id_1851.js"),
  1852: () => import("./layouts/Posters and Collages/product_id_1852.js"),
  1853: () => import("./layouts/Posters and Collages/product_id_1853.js"),
  1854: () => import("./layouts/Posters and Collages/product_id_1854.js"),
  1855: () => import("./layouts/Posters and Collages/product_id_1855.js"),
  1856: () => import("./layouts/Posters and Collages/product_id_1856.js"),
  2889: () => import("./layouts/Posters and Collages/product_id_2889.js"),
  // Posters and Collages Cateory Layouts Ends

};

// ================= Helpers ================= //
function getQueryParams() {
  try {
    const params = new URLSearchParams(window.location.search);
    return {
      productId: params.get("product_id")?.trim() || null,
      layoutId: params.get("layout_id") || null,
      productName: params.get("product_name") || "",
    };
  } catch {
    return { productId: null, layoutId: null, productName: "" };
  }
}

// Detect size/orientation from product name
function detectDetailsFromName(name) {
  if (!name) return { size: null, orientation: null };

  const cleanName = name.replace(/[–—-]/g, "-"); // normalize dash types
  const parts = cleanName.split("-").map((p) => p.trim());
  const lastPart = parts[parts.length - 1] || "";

  // Detect size like "10.5x8.5" or "8x10"
  const sizeMatch = lastPart.match(/(\d+(\.\d+)?)\s*[x×]\s*(\d+(\.\d+)?)/i);
  const size = sizeMatch ? `${sizeMatch[1]}x${sizeMatch[3]}` : null;

  // Detect orientation
  let orientation = null;
  if (/horizontal/i.test(lastPart)) orientation = "Horizontal";
  else if (/vertical/i.test(lastPart)) orientation = "Vertical";
  else if (/square/i.test(lastPart)) orientation = "Square";

  return { size, orientation };
}

// ================= Main Component ================= //
const CanvasContainer = () => {
  const { productId, productName } = useMemo(() => getQueryParams(), []);
  const { size, orientation } = useMemo(
    () => detectDetailsFromName(productName),
    [productName]
  );

  const [layoutExists, setLayoutExists] = useState(true);
  const [LayoutComponent, setLayoutComponent] = useState(() => DefaultLayout);

  // Load dynamic layout
  useEffect(() => {
    if (!productId) {
      setLayoutComponent(() => DefaultLayout);
      return;
    }

    const loader = layoutMap[productId];
    if (loader) {
      loader()
        .then((module) => {
          setLayoutExists(true);
          setLayoutComponent(() => module.default);
        })
        .catch(() => setLayoutExists(false));
    } else {
      setLayoutExists(false);
    }
  }, [productId]);

  // Log detected info (for debugging / dynamic logic)
  useEffect(() => {
    console.log("🧩 Detected from product name:", {
      productName,
      size,
      orientation,
    });
  }, [productName, size, orientation]);

// Use extracted inches directly (no DPI conversion)
function getCanvasDimensions(size, orientation) {
  let width = 10;
  let height = 8;

  if (size && size.includes("x")) {
    const [w, h] = size.split(/[x×]/).map((v) => parseFloat(v.trim()));
    if (!isNaN(w) && !isNaN(h)) {
      width = w;
      height = h;
    }
  }

  // Orientation logic
  if (orientation?.toLowerCase() === "horizontal") {
    [width, height] = [height, width];
  } else if (orientation?.toLowerCase() === "square") {
    const avg = (width + height) / 2;
    width = avg;
    height = avg;
  }

  return { width, height };
}

const baseSize = getCanvasDimensions(size, orientation); // inches
const DPI = 40;

const CANVAS_SIZE = {
  width: baseSize.width * DPI,
  height: baseSize.height * DPI
};

  // ================= SAVE CANVAS ================= //
  const handleSaveCanvas = async () => {
  const canvases = document.querySelectorAll("canvas");

  if (!canvases.length) {
    alert("No canvas found!");
    return;
  }

  const SCALE = 4; // Ultra-HD scale (2 = HD, 3 = QHD, 4 = 4K+)

  // Multiple canvases → ZIP
  if (canvases.length > 1) {
    const zip = new JSZip();
    const folder = zip.folder("photo_product_canvases");

    canvases.forEach((canvas, index) => {
      const width = canvas.width;
      const height = canvas.height;

      // Create off-screen Ultra-HD canvas
      const offscreen = document.createElement("canvas");
      offscreen.width = width * SCALE;
      offscreen.height = height * SCALE;

      const ctx = offscreen.getContext("2d");
      ctx.scale(SCALE, SCALE);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(canvas, 0, 0);

      // Convert to dataURL (lossless PNG)
      const dataURL = offscreen.toDataURL("image/png");
      const base64Data = dataURL.split(",")[1];

      folder.file(`canvas_page_${index + 1}.png`, base64Data, {
        base64: true,
      });
    });

    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, `photo_product_${productId || "canvas"}.zip`);
  } else {
    // Single canvas → Ultra-HD PNG
    const canvas = canvases[0];
    const width = canvas.width;
    const height = canvas.height;

    const offscreen = document.createElement("canvas");
    offscreen.width = width * SCALE;
    offscreen.height = height * SCALE;

    const ctx = offscreen.getContext("2d");
    ctx.scale(SCALE, SCALE);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(canvas, 0, 0);

    const dataURL = offscreen.toDataURL("image/png", 1.0);
    const link = document.createElement("a");
    link.href = dataURL;
    link.download = `photo_product_${productId || "canvas"}_ultraHD.png`;
    link.click();
  }
};

  // ================= RENDER ================= //
  return (
    <>
      {layoutExists ? (
        <div className="editor-shell">
          <TopBar onSave={handleSaveCanvas} />
          <div className="canvas-center">
            <Suspense fallback={<div>Loading canvas layout…</div>}>
              <LayoutComponent
                productId={productId}
                size={size}
                orientation={orientation}
                 canvasSize={CANVAS_SIZE}
              />
            </Suspense>
          </div>
        </div>
      ) : (
        <div className="layout-overlay">
          <div
            className="layout-missing-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="popup-title">Layout Missing</h2>
            <p className="popup-message">
              Layout for product ID <b>{productId}</b> doesn’t exist.
            </p>
            <button
              className="popup-button"
              onClick={() => window.history.back()}
            >
              Go Back
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CanvasContainer;
